import { EnvironmentProviders, InjectionToken, makeEnvironmentProviders } from '@angular/core';
import { SHARED_WORKER_DEFAULT_URL, SharedWorkerConfig } from '../models/shared-worker.models';

export const SHARED_WORKER_CONFIG = new InjectionToken<SharedWorkerConfig>('SHARED_WORKER_CONFIG');

export function provideSharedWorker(config: SharedWorkerConfig): EnvironmentProviders {
  const resolvedConfig: SharedWorkerConfig = {
    workerUrl: SHARED_WORKER_DEFAULT_URL,
    ...config,
  };

  return makeEnvironmentProviders([{ provide: SHARED_WORKER_CONFIG, useValue: resolvedConfig }]);
}
